const { Vue } = window;

window.homepageV2 = new Vue({
  el: '#main',
  data: {
    isTrialist: false
  },
  created: function() {
    this.checkTrialist();
  },
  methods: {
    checkTrialist() {
      if (window.getcookie('pv1') ||
          window.getcookie('pv2') ||
          window.getcookie('DemoLoginToken') ||
          window.getcookie('V2TrialLoginToken')) {
        this.isTrialist = true;
      }
    }
  }
});
